import { get, getBlob, post, put } from '../utils/axios'

export const getEmpsAPI = async (body) => {
  return await get('emps', body)
}
export const getSearchEmployeeAPI = async (body) => {
  return await get('emps/searchs', body)
}

// export const getTransferAPI = async (body) => {
//   return await get('transfer/employee', body)
// }

export const getEmpsExcelAPI = async (body) => {
  return await get('emps/excel', body)
}

// Backend now streams a real .xlsx (Meegle 14443031) instead of JSON — must go through getBlob,
// not get(), or the response body (binary) would be force-parsed as JSON and fail.
export const getEmpsExcelAllAPI = async (body) => {
  return await getBlob('emps/excel/all', body)
}

// Same as getEmpsExcelAllAPI but for the regular "ข้อมูลพนักงาน" export (Meegle 14443031
// follow-up) — new endpoint, `getEmpsExcelAPI`/`emps/excel` above stays JSON for any other caller.
export const getEmpsExcelExportAPI = async (body) => {
  return await getBlob('emps/excel/export', body)
}

export const getEmpsExcelIncomeAPI = async (body) => {
  return await get('emps/excel/income', body)
}

export const getEmpsExcelCheck2API = async () => {
  return await get('excels/pim')
}

//log QR typeId = 8
export const getEmpsExcelLog2API = async (typeId) => {
  return await post('excels/logs', typeId)
}

export const getEmpsExcelCheckAPI = async () => {
  return await get('emps/excel/check')
}

export const createEmpsAPI = async (body) => {
  return await post('emps', body)
}

export const updateEmpsAPI = async (params = {}, data = {}) => {
  return await put('emps', params, data)
}

export const getEmpsComeoutsAPI = async (param) => {
  return await get('emps/reports/comeouts', param)
}
// New
export const getMonthlyNewAPI = async (param) => {
  return await get('monthly/new', param)
}

export const getMonthResignAPI = async (param) => {
  return await get('monthly/resign', param)
}

export const getMonthAppointAPI = async (param) => {
  return await get('monthly/appoint', param)
}

export const getMonthBirthdayAPI = async (param) => {
  return await get('monthly/birthday', param)
}

export const getEmpsOriginsAPI = async () => {
  return await get('emps/origins')
}

export const getBloodsAPI = async () => {
  return await get('bloods')
}

export const getEmpsSupAPI = async (body) => {
  return await get('search/employee-sup', body)
}

export const getEmpsReportbyAPI = async (body) => {
  return await get('search/employee-head', body)
}

export const getEmpsCodeAPI = async (param) => {
  return await get('search/employee-code', param)
}

export const getEmpsUsernameAPI = async (param) => {
  return await get('search/employee-username', param)
}

export const getEmpsTypeDateAPI = async () => {
  return await get('types/date')
}

export const getEmpsDivisionThEngAPI = async (body) => {
  return await get('search/division/th-eng', body)
}

export const getEmpsDepartmentThEngAPI = async (body) => {
  return await get('search/department/th-eng', body)
}

export const getEmpsPositionAPI = async (param) => {
  return await get('search/position/th-eng', param)
}

export const getEmpsNameAPI = async (param) => {
  return await get('search/employee-name', param)
}
export const getEmpsChkCodeAPI = async (param) => {
  return await get('emps/checks/code', param)
}
export const getEmpsChkUsernameAPI = async (param) => {
  return await get('emps/checks/username', param)
}

export const getEmpsJobsAPI = async (param) => {
  return await get('emps/details/jobs', param)
}
export const updateEmpsJobsAPI = async (params = {}, data = {}) => {
  return await put('emps/details/jobs', params, data)
}

export const getEmpsPersonalsAPI = async (param) => {
  return await get('emps/details/personals', param)
}
export const updateEmpsPersonalsAPI = async (params = {}, data = {}) => {
  return await put('emps/details/personals', params, data)
}

export const getEmpsBirthdaysAPI = async (param) => {
  return await get('emps/reports/birthdays', param)
}

export const getEmpsPayrollsAPI = async (param) => {
  return await get('emps/reports/payrolls', param)
}

export const getEmpsProfilesAPI = async (param) => {
  return await get('emps/details/profiles', param)
}

export const getFundTypeAPI = async () => {
  return await get('pvds/plan')
}

export const getFundDivisionAPI = async () => {
  return await get('pvds/plan')
}

export const getEmployeeLookupByIdAPI = async (param) => {
  return await get('emps/lookup', param)
}

export const getEmployeeSecretaryAPI = async (param) => {
  return await get('search/employee-secretary', param)
}

export const getEmployeeChecksPaymentGroupAPI = async (param) => {
  return await get('emps/checks/payment/group', param)
}

export const getReportEducationAPI = async (param) => {
  return await get('report/education/list', param)
}

export const getEmpsDetailsByUUIDAPI = async (param) => {
  return await get('emps/details/searchs', param)
}

export const getEmployeeProjectsAPI = async (param) => {
  return await get('employee/projects', param)
}

export const getEmployeeAirportsAPI = async (param) => {
  return await get('employee/locations', param)
}
